// extracted by mini-css-extract-plugin
export default {"controlGroup":"RealSizeControl_controlGroup__4BLEY"};